export const getItem = (key, defaultValue = null) => {
    try {
        const raw = localStorage.getItem(key);
        if (raw === null) return defaultValue;

        let parsed = JSON.parse(raw);

        return parsed.value;

    } catch (e) {
        console.error(`In storage.js: Error retrieving item "${key}" - ${e.message}`);
        throw e;
    }
};

export const setItem = (key, value) => {
    try {
        const stashed = { value };
        localStorage.setItem(key, JSON.stringify(stashed));
    } catch (e) {
        console.error(`In storage.js: Error storing item "${key}" - ${e.message}`);
        throw e;
    }
};

export const removeItem = key => {
    try {
        localStorage.removeItem(key);
    } catch(e) {
        console.error(`In storage.js: Error removing "${key}" - ${e.message}`);
        console.error(e);
    }
};

export const cacheKeys = Object.freeze({
    logout: [
        'trt.lawfirms'
    ]
});

export default {
    getItem,
    setItem,
    removeItem,
    cacheKeys
};